'use client';

import { useState } from 'react';

import { FormattedMessage } from '@flipster/i18n';
import { createSingleChoice } from '@flipster/react/design-system/chip';
import { css } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';
import segment from '@flipster/utils/segment';
import { DynamicEarnEvent } from '@flipster/utils/segment/events/dynamic-earn';

import { useProductConfig } from '../../product-config';
import { AprChart } from './apr-chart';
import { PortfolioBreakdownChart } from './portfolio-breakdown-chart';
import { ShareTokenPriceChart } from './share-token-price-chart';
import { TvlChart } from './tvl-chart';

type ChartTab = 'apr' | 'tvl' | 'share-token-price';

const ChartTabChips = createSingleChoice<ChartTab>();

export const Performance = () => {
  const { productName } = useProductConfig();
  const [activeTab, setActiveTab] = useState<ChartTab>('apr');

  const handleTabChange = (tab: ChartTab) => {
    setActiveTab(tab);
    segment.track(DynamicEarnEvent.DynamicEarnProductDetailChipClick, {
      product_name: productName,
      button_name: tab,
    });
  };

  return (
    <section className={stack({ tabletDown: { gap: 20 }, tablet: { gap: 32 } })}>
      <h2 className={css({ textStyle: 'Title/L', color: 'content.default.level-5' })}>
        <FormattedMessage id='Earn.r251208.Performance' />
      </h2>

      <div
        className={stack({
          bg: 'background.default.level-1',
          rounded: 12,
          tabletDown: { p: 16, gap: 16 },
          tablet: { p: 20, gap: 24 },
        })}
      >
        <ChartTabChips value={activeTab} onChange={handleTabChange}>
          <ChartTabChips.Chip value='apr' label={<FormattedMessage id='Common.r251209.Apr' />} />
          <ChartTabChips.Chip value='tvl' label='TVL' />
          <ChartTabChips.Chip
            value='share-token-price'
            label={<FormattedMessage id='Earn.r251208.Share_token_price' />}
          />
        </ChartTabChips>

        {activeTab === 'apr' && <AprChart />}
        {activeTab === 'tvl' && <TvlChart />}
        {activeTab === 'share-token-price' && <ShareTokenPriceChart />}
      </div>

      <PortfolioBreakdownChart />
    </section>
  );
};
